import { darken, lighten, styled } from '@mui/material';
import MuiPaper, { PaperProps } from '@mui/material/Paper';
import Box from '../Box';
import Divider from '../Divider';
import Typography from '../Typography';

export interface IPaperProps extends PaperProps {
  header?: string;
  padding?: string;
}
const BoxHeader = styled(Box)(({ theme }) => ({
  // backgroundColor: lighten(theme.palette.primary.main, 0.6),
  height: "30px",
}));
const TypographyHeader = styled(Typography)(({ theme }) => ({
  color: darken(theme.palette.primary.main, 0.3),
}));
const Paper = (props: IPaperProps): JSX.Element => {
  return <MuiPaper
    {...props}
    sx={{ ...props.sx, padding: props.padding ? props.padding : 1, height: "100%", width: "100%" }}
  >
    {props.header &&
      <BoxHeader>
        <TypographyHeader paddingLeft={1} paddingBottom={0} variant="h5">{props.header}</TypographyHeader>
        {/* <Divider sx={{ margin: 1 }} /> */}
      </BoxHeader>}
    <Box sx={{ height: "100%", padding: 0 }}>
      {props.children}
    </Box>
  </MuiPaper>;
};

export default Paper;
